<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>Importar arquivo:</h3>
      </div>

      <div class="vx-row flex items-end mt-2">
        <!-- Mês de referência -->
        <div class="vx-col lg:w-1/4 w-full">
          <span>Mês de referência</span>
          <v-select
            :options="listMonths"
            label="label"
            :reduce="(item) => item.id"
            name="Mês de Referência"
            v-model="form.mesReferente"
          ></v-select>
        </div>

        <!-- Ano de referência -->
        <div class="vx-col lg:w-1/4 w-full">
          <span>Ano de referência</span>
          <v-select
            :options="listYears"
            label="label"
            name="Ano de Referência"
            v-model="form.anoReferente"
          ></v-select>
        </div>

        <!-- Regional -->
        <div class="vx-col lg:w-1/4 w-full">
          <span>Regional</span>
          <v-select
            :options="listRegionais"
            label="nome"
            name="Regional"
            :reduce="(item) => item.idRegional"
            v-model="form.idRegional"
            @input="getConsultores()"
          ></v-select>
        </div>

        <!-- Consultor -->
        <div class="vx-col lg:w-1/4 w-full">
          <span>Consultor</span>
          <v-select
            :options="listConsultores"
            label="nome"
            name="Consultor"
            :reduce="(item) => item.id_usuario"
            v-model="form.idUsuario"
            :disabled="!form.idRegional"
          ></v-select>
        </div>
      </div>

      <div class="vx-row flex items-end mt-2">
        <!-- Arquivo Selecionado -->
        <div class="vx-col lg:w-1/3 w-full">
          <vs-input
            class="w-full"
            v-model="fileName"
            label="Arquivo Selecionado (somente .xls e .xlsx):"
            disabled
          />
        </div>

        <div
          class="vx-col flex gap-5 flex-col w-full lg:flex-row lg:w-2/3 mt-3"
        >
          <!-- Selecionar -->
          <vs-button icon-pack="feather" icon="icon-check" @click="chooseFile"
            >Selecionar</vs-button
          >
          <!-- Limpar -->
          <vs-button
            color="danger"
            icon-pack="feather"
            icon="icon-trash-2"
            @click="clear"
            >Limpar</vs-button
          >

          <!-- Importar -->
          <vs-button
            color="success"
            icon-pack="feather"
            icon="icon-upload"
            :disabled="disableSubmitButton"
            @click="upload"
            >Importar</vs-button
          >

          <!-- Input type file -->
          <input
            id="fileUpload"
            hidden
            type="file"
            icon="upload_file"
            accept=".xlsx,.xls"
            @change="selectFileUpload"
          />
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import leadsService from '../service';
import jwt from 'jsonwebtoken';
import notify from '../../../../../utils/notify';

export default {
  props: ['idUsuarioUpload'],
  components: {
    vSelect,
  },
  computed: {
    disableSubmitButton() {
      return (
        !this.form.mesReferente ||
        !this.form.anoReferente ||
        !this.localFile ||
        !this.form.idRegional ||
        !this.form.idUsuario
      );
    },
  },

  data() {
    return {
      // Options
      listMonths: [
        { id: '01', label: 'Janeiro' },
        { id: '02', label: 'Fevereiro' },
        { id: '03', label: 'Março' },
        { id: '04', label: 'Abril' },
        { id: '05', label: 'Maio' },
        { id: '06', label: 'Junho' },
        { id: '07', label: 'Julho' },
        { id: '08', label: 'Agosto' },
        { id: '09', label: 'Setembro' },
        { id: '10', label: 'Outubro' },
        { id: '11', label: 'Novembro' },
        { id: '12', label: 'Dezembro' },
      ],
      listYears: [],
      listRegionais: [],
      listConsultores: [],

      // Form
      form: {
        mesReferente: null,
        anoReferente: null,
        idRegional: null,
        idUsuario: null,
        idUsuarioUpload: null,
        arquivo: null,
      },

      // Arquivo para upload
      localFile: null,
      fileName: null,
    };
  },
  methods: {
    getYears() {
      const anoAtual = new Date().getFullYear();
      for (let ano = anoAtual; ano >= 2022; ano--) {
        this.listYears.push(ano);
      }
    },

    async getRegionais() {
      try {
        this.$vs.loading();
        const result = await leadsService.getRegionais();
        this.listRegionais = result;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async getConsultores() {
      try {
        this.$vs.loading();
        this.form.idUsuario = null;
        const objSend = {
          idEmpresa: this.form.idEmpresa,
          idRegional: this.form.idRegional,
        };
        const result = await leadsService.getConsultores(objSend);
        this.listConsultores = result;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    chooseFile() {
      document.getElementById('fileUpload').click();
    },

    clear() {
      this.localFile = null;
      this.fileName = null;
      this.form.mesReferente = null;
      this.form.anoReferente = null;
      this.form.idRegional = null;
      this.form.idUsuario = null;
      document.getElementById('fileUpload').value = null;
    },

    selectFileUpload(event) {
      this.localFile = event.target.files[0];
      if (!this.localFile) return;

      this.fileName = this.localFile.name;
    },

    async upload() {
      try {
        this.$vs.loading();

        const formData = new FormData();
        formData.append('file', this.localFile);

        const resultUpload = await leadsService.uploadArquivo(
          formData,
          this.form.idUsuarioUpload,
        );

        this.form.arquivo = resultUpload.urlImage;
        formData.append('form', JSON.stringify(this.form));

        await leadsService.registrarArquivo(formData);

        this.$emit('refreshList');
        this.clear();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  mounted() {
    const token = localStorage.getItem('user-token');
    this.form.idUsuarioUpload = jwt.decode(token).id_usuario;
    this.getYears();
    this.getRegionais();
  },
};
</script>
